import {
    RatesRequestTestActionTypes,
    RatesRequestTestState,
    UPDATE_RATES_REQUEST_TEST_FILTERS
} from '../types/ratesrequesttest.types';
import {Reducer} from 'redux';

const initialState: RatesRequestTestState = {
    filters: null
};

export const ratesRequestTestReducer: Reducer<RatesRequestTestState> = (
    state: RatesRequestTestState = initialState, action
) => {
    switch ((action as RatesRequestTestActionTypes).type) {
        case UPDATE_RATES_REQUEST_TEST_FILTERS:
            return {
                ...state,
                filters: action.payload.filters
            };
        default:
            return state;
    }
};
